import React from "react"
import { Box } from "src/UILibrary"

export const Top: React.FC = () => {
  return <Box sx={{ my: "0 auto" }} id="signin_box"></Box>
}
